// Enregistrement du service worker et bascule de version contrôlée.

let waiting = null;
let registration = null;

// onUpdateReady est appelé quand une nouvelle version a fini de se précacher et attend.
async function registerServiceWorker(onUpdateReady) {
    if (!('serviceWorker' in navigator)) return null;
    try {
        registration = await navigator.serviceWorker.register('/sw.js');

        const track = worker => {
            if (!worker) return;
            worker.addEventListener('statechange', () => {
                if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                    waiting = worker;
                    onUpdateReady();
                }
            });
        };

        // Une version peut déjà attendre depuis une visite précédente.
        if (registration.waiting && navigator.serviceWorker.controller) {
            waiting = registration.waiting;
            onUpdateReady();
        }
        track(registration.installing);
        registration.addEventListener('updatefound', () => track(registration.installing));
        return registration;
    } catch (e) {
        console.warn('service worker non enregistré :', e);
        return null;
    }
}

function isUpdateWaiting() { return !!waiting; }

// À n'appeler que hors suivi GPS : la page se recharge.
function applyUpdate() {
    if (!waiting) return;
    navigator.serviceWorker.addEventListener('controllerchange', () => location.reload());
    waiting.postMessage({ type: 'SKIP_WAITING' });
}

// Vérification manuelle, à ne déclencher que quand le chauffeur ne roule pas.
function checkForUpdate() {
    if (registration) registration.update().catch(() => {});
}

export { registerServiceWorker, isUpdateWaiting, applyUpdate, checkForUpdate };
